import React from "react"
import "./projects.css"
import Image from "./image"

const Projects = props => {
  const { title, projects } = props

  return (
    <div className="projects">
      <h2 className="rv-pb-2">{title}</h2>
      {projects.map((project, i) => {
        const projectTypeSuffix =
          project.projectTypeSuffix.charAt(0).toUpperCase() +
          project.projectTypeSuffix.slice(1)

        if (project.description) {
          return (
            <div
              key={i}
              className="project rv-flex rv-flex-col rv-gap-2 rv-mb-5"
            >
              <h3>
                <a
                  className="project-title"
                  title={project.name}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={project.url}
                >
                  <span className="w-name">{project.name}</span>
                  {/* <span className="w-tld">{project.tld}</span> */}
                </a>
              </h3>
              <div className="rv-flex rv-gap-4">
                {project.image && (
                  <Image
                    alt={`${project.name} preview`}
                    fileName={project.image}
                    className="rv-rounded-md rv-overflow-hidden"
                    lightbox
                    lightboxLinkUrl={project.url}
                    lightboxLinkLabel={`View ${projectTypeSuffix}`}
                  />
                )}
                <p>
                  <span className="description rv-block">
                    {project.description}
                  </span>
                  <span className="tech rv-block rv-pt-1">
                    {project.techStack.join(" | ")}
                  </span>
                  <a
                    className="target-link"
                    href={project.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    View {projectTypeSuffix}
                  </a>
                </p>
              </div>
            </div>
          )
        }

        return <React.Fragment key={i} />
      })}
    </div>
  )
}

export default Projects
